// Library imports
import styled from 'styled-components';

export const ModalBodyWrapper = styled.div`
    padding: 0;
`;

export const LoadingContainer = styled.div`
    text-align: center;
    padding: 1rem;
`;

export const NoDataContainer = styled.div`
    text-align: center;
    padding: 1rem;
`;

export const GameHeader = styled.div`
    background: ${({ $gameData }) =>
        $gameData?.awayTeam?.color && $gameData?.homeTeam?.color
            ? `linear-gradient(135deg, ${$gameData.awayTeam.color} 0%, ${$gameData.homeTeam.color} 100%)`
            : $gameData?.winner === $gameData?.awayTeam?.teamId
            ? `linear-gradient(135deg, ${$gameData?.awayTeam?.color || '#667eea'} 0%, ${$gameData?.awayTeam?.color || '#764ba2'} 100%)`
            : $gameData?.winner === $gameData?.homeTeam?.teamId
            ? `linear-gradient(135deg, ${$gameData?.homeTeam?.color || '#667eea'} 0%, ${$gameData?.homeTeam?.color || '#764ba2'} 100%)`
            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'};
    color: white;
    padding: 24px;
    position: relative;
    overflow: hidden;
`;

export const HeaderContent = styled.div`
    position: relative;
    z-index: 2;
`;

export const TeamsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`;

export const TeamInfo = styled.div`
    text-align: center;
    flex: 1;
`;

export const TeamAbbreviation = styled.div`
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 4px;
`;

export const TeamFullName = styled.div`
    font-size: 14px;
    opacity: 0.9;
`;

export const ScoreContainer = styled.div`
    display: flex;
    align-items: center;
    font-size: 28px;
    font-weight: bold;
    margin: 0 20px;
`;

export const ScoreBox = styled.span`
    background: ${({ $isWinner }) => ($isWinner ? 'rgba(40, 167, 69, 0.3)' : 'rgba(255,255,255,0.2)')};
    padding: 8px 12px;
    border-radius: 8px;
    margin-right: ${({ $isAway }) => ($isAway ? '8px' : '0')};
    margin-left: ${({ $isAway }) => ($isAway ? '0' : '8px')};
`;

export const ScoreDivider = styled.span`
    opacity: 0.7;
    font-size: 16px;
`;

export const DateTime = styled.div`
    text-align: center;
    font-size: 14px;
    opacity: 0.9;
`;

export const BackgroundPattern = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    background-image: radial-gradient(circle at 25% 25%, white 2px, transparent 2px);
    background-size: 30px 30px;
`;

export const GameStatsWrapper = styled.div`
    padding: 24px;
`;

export const Section = styled.div`
    margin-bottom: 24px;
`;

export const SectionHeader = styled.h6`
    margin-bottom: 16px;
    color: #495057;
    border-bottom: 2px solid #e9ecef;
    padding-bottom: 8px;
    text-align: ${({ $centered }) => ($centered ? 'center' : 'left')};
`;

export const PitchersGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px;
`;

export const PitcherCard = styled.div`
    background: #f8f9fa;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #dee2e6;
`;

export const PitcherHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
`;

export const PitcherName = styled.div`
    font-size: 16px;
    font-weight: bold;
    color: #495057;
`;

export const PitcherTeam = styled.div`
    font-size: 12px;
    color: #6c757d;
`;

export const PitcherStats = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    font-size: 12px;
`;

export const PitcherStat = styled.div`
    text-align: center;
`;

export const PitcherStatValue = styled.div`
    font-weight: bold;
    color: #495057;
`;

export const PitcherStatLabel = styled.div`
    color: #6c757d;
`;

export const GameId = styled.div`
    font-size: 12px;
    color: #6c757d;
    text-align: center;
    padding: 8px;
    background: #f8f9fa;
    border-radius: 8px;
`;

export const BettingSubsection = styled.div`
    margin-bottom: 16px;
`;

export const BettingSubheader = styled.div`
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 8px;
    color: #495057;
`;

export const BookList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const BookItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px;
`;

export const BookInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const BookLogo = styled.img`
    width: 24px;
    height: 24px;
    border-radius: 4px;
    background-color: ${({ $bookColor }) => $bookColor || '#f8f9fa'};
    padding: 2px;
`;

export const BookLabel = styled.span`
    font-size: 14px;
    font-weight: 500;
`;

export const OddsContainer = styled.div`
    display: flex;
    gap: 16px;
`;

export const OddsSection = styled.div`
    text-align: center;
`;

export const TeamAbbrev = styled.div`
    font-size: 12px;
    color: #6c757d;
`;

export const MoneylineOdds = styled.div`
    font-size: 14px;
    font-weight: bold;
    color: ${({ $line }) => ($line > 0 ? '#28a745' : '#dc3545')};
`;

export const SpreadOdds = styled.div`
    font-size: 14px;
    font-weight: bold;
    color: #495057;
`;
